import { useState } from 'react'
import { FiUpload } from 'react-icons/fi'
import { IoClose } from 'react-icons/io5'
import { base_url, department } from '../constant/Appconstants'
import ErrorComponent from '../constant/ErrorComponent'
import axios from 'axios'
import { message } from 'antd'
import { useNavigate } from 'react-router-dom'

function Carrer() {
  const navigator = useNavigate()

  const [data, setdata] = useState({
    name: '',
    mobile: '',
    email: '',
    experience: '',
    previous_company: '',
    query: '',
    file: ''
  })

  const [error, seterror] = useState({
    name: '',
    mobile: '',
    email: '',
    experience: '',
    previous_company: '',
    query: '',
    file: ''
  })

  function handleChange(e) {
    setdata({ ...data, [e.target.name]: e.target.value })
    seterror({ ...error, [e.target.name]: '' })
  }

  async function submitForm() {
    if (!data?.name) {
      seterror({ ...error, name: 'This Field is required *' })
    } else if (!data?.mobile || data.mobile.length < 10) {
      seterror({ ...error, mobile: 'Valid mobile number is required *' })
    } else if (!data?.email) {
      seterror({ ...error, email: 'This Field is required *' })
    } else if (!data?.experience) {
      seterror({ ...error, experience: 'This Field is required *' })
    } else if (!data?.file) {
      seterror({ ...error, file: 'This Field is required *' })
    } else {
      const fd = new FormData()

      fd.append('name', data?.name)
      fd.append('mobile', data?.mobile)
      fd.append('email', data?.email)
      fd.append('experience', data?.experience)
      fd.append('previous_company', data?.previous_company)
      fd.append('query', data?.query)
      fd.append('file', data?.file)
      fd.append('department_website', department)

      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      await axios
        .post(`${base_url}applicant/create`, fd, headers)
        .then((res) => {
          if (res?.status === 201) {
            message.success('Form Submitted Successfully')
            setdata({
              name: '',
              mobile: '',
              email: '',
              experience: '',
              previous_company: '',
              query: '',
              file: ''
            })
            seterror({
              name: '',
              mobile: '',
              email: '',
              experience: '',
              previous_company: '',
              query: '',
              file: ''
            })
          }
        })
        .catch(() => {
          message.error('Something went wrong. Please try again.')
        })
    }
  }

  const whyWorkWithUs = [
    'Opportunities across India',
    'Stable and supportive work environment',
    'Career growth and training programs',
    'Work with reputed clients'
  ]

  const openPositions = [
    'Facility Management Staff',
    'Housekeeping Executives',
    'Security Personnel',
    'Office Support Staff',
    'Operations Supervisors'
  ]

  return (
    <div className="w-full h-full bg-white">

      {/* Hero Section */}
      <div className="h-[140px] relative md:min-h-[240px] 2xl:min-h-[500px] bg-cover md:bg-cover bg-no-repeat w-full bg-joinus_bg">
        <div className="border-l w-[75%] md:w-[35%] border-l-4 border-l-[#4190ac] ml-[2%] pl-[1.5%] absolute top-[15%]">
          <h6 className="text-[19px] 2xl:text-[22px] font_thicker md:text-[21px] text-white font-[800]">
            Build Your Career with Fidelitus
          </h6>
          <h6 className="text-[13px] 2xl:text-[16px] font_normal md:text-[14px] text-white">
            Join a growing organization where your skills and dedication are valued. At Fidelitus, we provide opportunities for growth, stability, and professional development.
          </h6>
        </div>
      </div>

      {/* Added Career Info Section */}
      <section className="relative px-6 py-14 overflow-hidden bg-gradient-to-br from-[#f4fbfd] via-white to-[#eef8fb] md:px-[10%]">
        <div className="max-w-6xl mx-auto">

          <div data-aos="fade-up" className="text-center">
            <h6 className="font_thicker text-[24px] md:text-[34px] 2xl:text-[42px] text-slate-900">
              Why Work <span className="text-[#4190ac]">With Us</span>
            </h6>

            <div className="flex items-center justify-center w-full mt-2">
              <span className="w-[80px] h-[3px] bg-[#e58c3d] block"></span>
              <span className="w-[30px] h-[6px] bg-[#e58c3d] block"></span>
            </div>

            <p className="max-w-3xl mx-auto mt-5 font_normal text-[14px] md:text-[16px] text-gray-600">
              Be part of a professional team that delivers excellence every day across India.
            </p>
          </div>

          <div className="grid gap-5 mt-10 md:grid-cols-4">
            {whyWorkWithUs.map((item, index) => (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
                className="p-5 transition bg-white border border-gray-100 shadow-sm rounded-xl hover:shadow-lg"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#4190ac]/10 text-[#4190ac] font_thicker mb-4">
                  {index + 1}
                </div>
                <h6 className="font_thicker text-[15px] md:text-[16px] text-slate-900">
                  {item}
                </h6>
              </div>
            ))}
          </div>

          <div className="w-full h-[1px] bg-gray-300 my-12"></div>

          <div className="grid items-center gap-8 md:grid-cols-2">
            <div data-aos="fade-right">
              <h6 className="flex items-center gap-3 font_thicker text-[24px] md:text-[32px] text-slate-900">
                <span className="w-4 h-4 bg-[#4190ac] rotate-45 inline-block"></span>
                Open Positions
              </h6>

              <p className="mt-4 font_normal text-[14px] md:text-[16px] text-gray-600">
                Explore current job openings and take the next step in your career.
              </p>

              <div className="grid grid-cols-1 gap-3 mt-6 sm:grid-cols-2">
                {openPositions.map((position, index) => (
                  <div
                    key={index}
                    className="px-4 py-3 text-[13px] md:text-[14px] font_normal bg-white border-l-4 border-[#e58c3d] shadow-sm"
                  >
                    {position}
                  </div>
                ))}
              </div>
            </div>

            <div data-aos="fade-left" className="p-6 bg-white border border-gray-100 shadow-md rounded-2xl">
              <h6 className="font_thicker text-[22px] md:text-[28px] text-slate-900">
                Ready to Apply?
              </h6>

              <p className="mt-3 font_normal text-[14px] md:text-[16px] text-gray-600">
                Share your details with us and our team will connect with you once your profile is shortlisted.
              </p>

              <a
                href="#apply-now"
                className="inline-block px-6 py-3 mt-6 text-[13px] md:text-[14px] font_normal text-white bg-[#4190ac] hover:bg-[#e58c3d] transition"
              >
                Apply Now
              </a>
            </div>
          </div>

          <div className="mt-12 text-center" data-aos="fade-up">
            <p className="mt-3 font_normal text-[15px] md:text-[18px] text-gray-700">
              Be a part of a team that delivers excellence every day.
            </p>
          </div>

        </div>
      </section>

      {/* Application Form Section */}
      <div>
        <div id="apply-now" className="w-[80vw] mx-auto py-10">
          <div>
            <div className="flex-row-reverse md:flex-row md:flex">
              <div data-aos="fade-up" className="md:mt-10 md:w-[48%]">
                <h6 className="ml-1 text-[26px] 2xl:text-[29px] font_thicker w-[100%] md:w-[70%]">
                  Looking to Join our Family as an FMS Employee.
                </h6>

                <h6 className="mt-5 text-gray-600 w-[100%] mx-auto text-[14px]">
                  Contact us and you&apos;ll receive a call as soon as you get shortlisted
                </h6>

                <div className="w-full mt-5">
                  <h6 className="mb-1 font_normal text-[13px] 2xl:text-[16px]">Name</h6>
                  <input type="text" name="name" value={data?.name} onChange={handleChange} className="border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]" />
                </div>
                <ErrorComponent error={error?.name} />

                <div className="w-full mt-2">
                  <h6 className="mb-1 font_normal text-[13px] 2xl:text-[16px]">Mobile</h6>
                  <input type="text" name="mobile" value={data?.mobile} onChange={handleChange} className="border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]" />
                </div>
                <ErrorComponent error={error?.mobile} />

                <div className="w-full mt-2">
                  <h6 className="mb-1 font_normal text-[13px] 2xl:text-[16px]">Email</h6>
                  <input type="text" name="email" value={data?.email} onChange={handleChange} className="border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]" />
                </div>
                <ErrorComponent error={error?.email} />

                <div className="w-full mt-2">
                  <h6 className="mb-1 font_normal text-[13px] 2xl:text-[16px]">Experience</h6>
                  <input min={0} name="experience" value={data?.experience} onChange={handleChange} type="number" className="border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]" />
                </div>
                <ErrorComponent error={error?.experience} />

                <div className="w-full mt-2">
                  <h6 className="mb-1 font_normal text-[13px] 2xl:text-[16px]">Previous Company</h6>
                  <input type="text" name="previous_company" value={data?.previous_company} onChange={handleChange} className="border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]" />
                </div>

                <div className="w-full mt-2">
                  <h6 className="mb-1 text-[13px] 2xl:text-[16px]">Upload Resume</h6>

                  {data?.file === '' ? (
                    <form
                      onClick={() => document.querySelector('.input-field').click()}
                      className="flex flex-col items-center justify-center p-4 border border-dashed rounded cursor-pointer"
                    >
                      <FiUpload size={24} />
                      <span className="font-bold font_normal text-[10px] 2xl:text-[13px] mt-1 text-center">
                        Click To Upload Resume
                      </span>
                      <span className="font-bold font_normal text-[7px] 2xl:text-[10px] mt-0 text-center">
                        Supported Type PDF, DOC, DOCX, JPEG, PNG
                      </span>
                      <input
                        type="file"
                        onChange={({ target: { files } }) => {
                          files[0] && setdata({ ...data, file: files[0] })
                          seterror({ ...error, file: '' })
                        }}
                        accept=".pdf,.doc,.docx,image/*"
                        className="input-field"
                        hidden
                      />
                    </form>
                  ) : (
                    <div className="relative flex p-2 border">
                      <h6 className="text-[13px] 2xl:text-[16px] font_normal truncate w-[95%] pl-2">
                        {data?.file?.name}
                      </h6>
                      <IoClose
                        className="absolute cursor-pointer right-2"
                        onClick={() => {
                          setdata({ ...data, file: '' })
                          seterror({ ...error, file: '' })
                        }}
                      />
                    </div>
                  )}
                </div>
                <ErrorComponent error={error?.file} />

                <div className="w-full mt-2">
                  <h6 className="mb-1 font_normal text-[13px] 2xl:text-[16px]">Query</h6>
                  <textarea name="query" value={data?.query} onChange={handleChange} className="w-full p-1 border focus:ring-0 focus:outline-none" />
                </div>

                <button onClick={submitForm} className="text-[12px] 2xl:text-[15px] flex font_normal mt-2 items-end justify-end bg-black text-white p-2">
                  SUBMIT
                </button>
              </div>

              <div data-aos="fade-up" className="md:ml-[4%] md:w-[48%] mt-10">
                <div className="w-[100%]">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.201402509898!2d77.5725512!3d12.9205498!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14293cbbedf9%3A0x4f12794ce5a209a4!2sFidelitus%20Corp!5e0!3m2!1sen!2sin!4v1691664501989!5m2!1sen!2sin"
                    className="w-full"
                    height="400"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PAN India Section */}
      <h1 data-aos="fade-up" className="text-center font_thicker text-[17px] mt-10">
        Be Part of Our <span className="text-[#4190ac] font_medium">Growing PAN India </span> Presence
      </h1>

      <div className="grid items-center justify-center grid-cols-3 px-10 mt-10 mb-20 place-self-center place-content-center md:flex">
        {[
          'BANGALORE',
          'HYDERABAD',
          'CHENNAI',
          'MUMBAI',
          'DELHI',
          'AHMEDABAD',
          'KOLKATA',
          'PUNE',
          'KOCHI',
          'SALEM',
          'GURGAON',
          'MANAGALORE',
          'HASAN',
          'KALBURGI',
          'KERALA',
          'HAMPI',
          'HOSPET',
          'TUMAKUR',
          'CHIKKAMAGALORE',
          'SHIVAMOGGA'
        ].map((city, index) => (
          <span
            key={index}
            data-aos="fade-up"
            data-aos-delay="300"
            className="px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black"
          >
            {city}
          </span>
        ))}
      </div>
    </div>
  )
}

export default Carrer









// import {useState} from 'react'
// import {FiUpload} from 'react-icons/fi'
// import {IoClose} from 'react-icons/io5'
// import { base_url, department } from '../constant/Appconstants'
// import ErrorComponent from '../constant/ErrorComponent'
// import axios from 'axios'
// import {message} from 'antd'
// import Typist from 'react-typist';
// import { useNavigate } from 'react-router-dom'

// function Carrer() {

//   const navigator = useNavigate();
//   const [data,setdata] = useState({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
//   const [error,seterror] = useState({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})

//   function handleChange(e){
//     setdata({...data,[e.target.name]:e.target.value})
//     seterror({...error,[e.target.name]:''})
//   } 

//   async function submitForm(){
//     if(!data?.name){
//       seterror({...error,name:'This Field is required *'})
//     }else if(!data?.mobile && data.mobile.length < 10){
//       seterror({...error,mobile:'This Field is required *'})
//     }else if(!data?.email){
//       seterror({...error,email:'This Field is required *'})
//     }else if(!data?.experience){
//       seterror({...error,experience:'This Field is required *'})
//     }else if(!data?.file){
//       seterror({...error,file:'This Field is required *'})
//     }else{

//       const fd = new FormData()
//       fd.append('name',data?.name)
//       fd.append('mobile',data?.mobile)
//       fd.append('email',data?.email)
//       fd.append('experience',data?.experience)
//       fd.append('previous_company',data?.previous_company)
//       fd.append('query',data?.query)
//       fd.append('file',data?.file)
//       fd.append('department_website',department)

//       const headers = {headers:{
//         'Content-Type':'multipart/form-data'
//       }}
      
//       await axios.post(`${base_url}applicant/create`,fd,headers)
//       .then((res)=>{
//         if(res?.status === 201){
//           message.success('Form Submitted Successfully')
//           setdata({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
//           seterror({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
//         }
//       }).catch((err)=>{      
//       }) 
//     }
//   }

//   return (
//     <div className="w-full h-full bg-white">
//         <div className='h-[140px]  relative md:min-h-[240px] 2xl:min-h-[500px] bg-cover md:bg-cover bg-no-repeat w-full bg-joinus_bg'>
//             <div className='border-l w-[75%] md:w-[35%] border-l-4  border-l-[#4190ac] ml-[2%] pl-[1.5%] absolute top-[15%]'>
//                 {/* <Typist avgTypingDelay={15} stdTypingDelay={15}> */}
//                 <h6 className='text-[19px] 2xl:text-[22px] font_thicker md:text-[21px] text-[#fff] font-[800]  '>Build Your Career with Fidelitus</h6>
//                 <h6 className='text-[13px] 2xl:text-[16px] font_normal md:text-[14px] text-[#fff]'>Join a growing organization where your skills and dedication are valued. At Fidelitus, we provide opportunities for growth, stability, and professional development.</h6>
//                 {/* </Typist> */}
//             </div>
//         </div>
//         <div className=''>
//         <div className='w-[80vw] mx-auto py-10'>
       

//         <div>

           
//            <div className='flex-row-reverse md:flex-row md:flex '>
//               <div data-aos="fade-up" className='md:mt-10 md:w-[48%]'>
//                   <h6 className='ml-1 text-[26px] 2xl:text-[29px] font_thicker w-[100%] md:w-[70%]'>Looking to Join our Family as an FMS Employee.</h6>

//                   <h6 className=' mt-5 text-gray-600 w-[100%]  mx-auto text-[14px]'>Contact us and you&apos;ll receive a call as soon as you get shortlisted </h6>
//                   <div className='w-full mt-5'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Name</h6>
//                 <input type='text' name="name" value={data?.name} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
//               </div>

//               <ErrorComponent error={error?.name} />

//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Mobile</h6>
//                 <input type='text' name="mobile" value={data?.mobile} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
//               </div>
//               <ErrorComponent error={error?.mobile} />


//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Email</h6>
//                 <input type='text' name="email" value={data?.email} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
//               </div>
//               <ErrorComponent error={error?.email} />


//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Experience</h6>
//                 <input min={0} name="experience" value={data?.experience} onChange={handleChange} type='number' className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
//               </div>

//               <ErrorComponent error={error?.experience} />



//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Previous Company</h6>
//                 <input type='text'  name="previous_company" value={data?.previous_company} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
//               </div>


//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 text-[13px] 2xl:text-[16px]'>Upload Resume</h6>
//                 {data?.file === '' ? 
//                 <form onClick={()=>document.querySelector('.input-field').click()} className={`p-4 flex flex-col items-center justify-center cursor-pointer rounded   border-dashed border`}>
//                   <FiUpload size={24} />
//                   <span className='font-bold font_normal text-[10px] 2xl:text-[13px] mt-1 text-center'>Click To Upload Photo</span>
//                   <span className='font-bold font_normal text-[7px] 2xl:text-[10px] mt-0 text-center'>Supported Type JPEG,PNG,SVG,WEBP</span>
//                   <input type='file' onChange={({target:{files}})=>{
//                     files[0] && setdata({...data,file:files[0]});seterror({...error,file:''})
//                   }} accept="image/*" className='input-field' hidden />
//                </form> 
//                 :
//                 <div className='relative flex p-2 border'>
//                     <h6 className='text-[13px] 2xl:text-[16px] font_normal truncate w-[95%] pl-2'>{data?.file?.name}</h6>
//                     <IoClose className='absolute right-2' onClick={()=>{setdata({...data,file:''});seterror({...error,file:''})}}/>
//                 </div>  
//                 }

//               </div>

//               <ErrorComponent error={error?.file} />


//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Query</h6>
//                 <textarea name="query" value={data?.query} onChange={handleChange} type='text' className='w-full p-1 border focus:ring-0 focus:outline-none' />
//               </div>


//                   <button onClick={submitForm} className='text-[12px] 2xl:text-[15px] flex font_normal mt-2 items-end justify-end bg-black text-white p-2'>
//                     SUBMIT
//                   </button>

//               </div>

//               <div data-aos="fade-up" className='md:ml-[4%] md:w-[48%] mt-10'>
//                 <div className='w-[100%]'>
//                 <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.201402509898!2d77.5725512!3d12.9205498!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14293cbbedf9%3A0x4f12794ce5a209a4!2sFidelitus%20Corp!5e0!3m2!1sen!2sin!4v1691664501989!5m2!1sen!2sin" className='w-full' height="400"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
//                 </div>
//               </div>
//            </div>
           
//         </div>
//         </div>
//         </div>
//       <h1 data-aos="fade_up" className=' text-center font_thicker text-[17px] mt-10'>Be Part of Our   <span className='text-[#4190ac] font_medium'>Growing PAN India </span>  Presence</h1>


//       <div className='grid items-center justify-center grid-cols-3 px-10 mt-10 mb-20 place-self-center place-content-center md:flex'>
//         <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black border-l md:border-l-0'>BANGALORE</span>
//         <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>HYDERABAD</span>
//         <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>CHENNAI</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black border-l md:border-l-0'>MUMBAI</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>DELHI</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>AHMEDABAD</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black border-l md:border-l-0'>KOLKATA</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>PUNE</span>
//         <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black md:border-none'>KOCHI</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>SALEM</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>GURGAON</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black border-l md:border-l-0'>MANAGALORE</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>HASAN</span>
//         <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black md:border-none'>KALBURGI</span>
//        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>KERALA</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>HAMPI</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black border-l md:border-l-0'>HOSPET</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>TUMAKUR</span>
//         <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black md:border-none'>CHIKKAMAGALORE</span>
//         <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black md:border-none'>SHIVAMOGGA</span>
//       </div>
//     </div>
//   )
// }

// export default Carrer









//============>> Old one


// import {useState} from 'react'
// import {FiUpload} from 'react-icons/fi'
// import {IoClose} from 'react-icons/io5'
// import { base_url, department } from '../constant/Appconstants'
// import ErrorComponent from '../constant/ErrorComponent'
// import axios from 'axios'
// import {message} from 'antd'
// import Typist from 'react-typist';
// import { useNavigate } from 'react-router-dom'

// function Carrer() {

//   const navigator = useNavigate();
//   const [data,setdata] = useState({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
//   const [error,seterror] = useState({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})

//   function handleChange(e){
//     setdata({...data,[e.target.name]:e.target.value})
//     seterror({...error,[e.target.name]:''})
//   } 

//   async function submitForm(){
//     if(!data?.name){
//       seterror({...error,name:'This Field is required *'})
//     }else if(!data?.mobile && data.mobile.length < 10){
//       seterror({...error,mobile:'This Field is required *'})
//     }else if(!data?.email){
//       seterror({...error,email:'This Field is required *'})
//     }else if(!data?.experience){
//       seterror({...error,experience:'This Field is required *'})
//     }else if(!data?.file){
//       seterror({...error,file:'This Field is required *'})
//     }else{

//       const fd = new FormData()
//       fd.append('name',data?.name)
//       fd.append('mobile',data?.mobile)
//       fd.append('email',data?.email)
//       fd.append('experience',data?.experience)
//       fd.append('previous_company',data?.previous_company)
//       fd.append('query',data?.query)
//       fd.append('file',data?.file)
//       fd.append('department_website',department)

//       const headers = {headers:{
//         'Content-Type':'multipart/form-data'
//       }}
      
//       await axios.post(`${base_url}applicant/create`,fd,headers)
//       .then((res)=>{
//         if(res?.status === 201){
//           message.success('Form Submitted Successfully')
//           setdata({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
//           seterror({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
//         }
//       }).catch((err)=>{      
//       }) 
//     }
//   }

//   return (
//     <div className="w-full h-full bg-white">
//         <div className='h-[140px]  relative md:min-h-[240px] 2xl:min-h-[500px] bg-cover md:bg-cover bg-no-repeat w-full bg-joinus_bg'>
//             <div className='border-l w-[75%] md:w-[35%] border-l-4  border-l-[#4190ac] ml-[2%] pl-[1.5%] absolute top-[15%]'>
//                 {/* <Typist avgTypingDelay={15} stdTypingDelay={15}> */}
//                 <h6 className='text-[19px] 2xl:text-[22px] font_thicker md:text-[21px] text-[#fff] font-[800]  '>Build Your Career with Fidelitus</h6>
//                 <h6 className='text-[13px] 2xl:text-[16px] font_normal md:text-[14px] text-[#fff]'>Join a growing organization where your skills and dedication are valued. At Fidelitus, we provide opportunities for growth, stability, and professional development.</h6>
//                 {/* </Typist> */}
//             </div>
//         </div>

//       {/* <div className='h-[250px] w-screen overflow-hidden relative md:h-[400px] grid place-items-center  bg-[#f7f3ef]  '>
      
//        <div >
//         <h1 className='text-center text-[40px]'>Contact us</h1>

//         <h6 className='text-center tracking-wider text-black-400 text-[14px]'> <span className='cursor-pointer'>Home</span> / Contact us</h6>
//         <h6 className='text-center tracking-wider text-black-400 text-[12px]'>24/7 We are ready to assist you!</h6>
//         </div>

//         <img src={GLobe} className="absolute -right-[35vw]  animate-rotate-full   h-[250px]  md:h-[400px] object-contain " />
//         <img src={User} className="absolute -right-[28%] md:right-0 top-10   h-[250px]  md:h-[400px] object-contain " />

//       </div> */}

//         <div className=''>
//         <div className='w-[80vw] mx-auto py-10'>
       

//         <div>

           
//            <div className='flex-row-reverse md:flex-row md:flex '>
//               <div data-aos="fade-up" className='md:mt-10 md:w-[48%]'>
//                   <h6 className='ml-1 text-[26px] 2xl:text-[29px] font_thicker w-[100%] md:w-[70%]'>Looking to Join our Family as an FMS Employee.</h6>

//                   <h6 className=' mt-5 text-gray-600 w-[100%]  mx-auto text-[14px]'>Contact us and you&apos;ll receive a call as soon as you get shortlisted </h6>
//                   <div className='w-full mt-5'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Name</h6>
//                 <input type='text' name="name" value={data?.name} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
//               </div>

//               <ErrorComponent error={error?.name} />

//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Mobile</h6>
//                 <input type='text' name="mobile" value={data?.mobile} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
//               </div>
//               <ErrorComponent error={error?.mobile} />


//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Email</h6>
//                 <input type='text' name="email" value={data?.email} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
//               </div>
//               <ErrorComponent error={error?.email} />


//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Experience</h6>
//                 <input min={0} name="experience" value={data?.experience} onChange={handleChange} type='number' className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
//               </div>

//               <ErrorComponent error={error?.experience} />



//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Previous Company</h6>
//                 <input type='text'  name="previous_company" value={data?.previous_company} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
//               </div>


//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 text-[13px] 2xl:text-[16px]'>Upload Resume</h6>
//                 {data?.file === '' ? 
//                 <form onClick={()=>document.querySelector('.input-field').click()} className={`p-4 flex flex-col items-center justify-center cursor-pointer rounded   border-dashed border`}>
//                   <FiUpload size={24} />
//                   <span className='font-bold font_normal text-[10px] 2xl:text-[13px] mt-1 text-center'>Click To Upload Photo</span>
//                   <span className='font-bold font_normal text-[7px] 2xl:text-[10px] mt-0 text-center'>Supported Type JPEG,PNG,SVG,WEBP</span>
//                   <input type='file' onChange={({target:{files}})=>{
//                     files[0] && setdata({...data,file:files[0]});seterror({...error,file:''})
//                   }} accept="image/*" className='input-field' hidden />
//                </form> 
//                 :
//                 <div className='relative flex p-2 border'>
//                     <h6 className='text-[13px] 2xl:text-[16px] font_normal truncate w-[95%] pl-2'>{data?.file?.name}</h6>
//                     <IoClose className='absolute right-2' onClick={()=>{setdata({...data,file:''});seterror({...error,file:''})}}/>
//                 </div>  
//                 }

//               </div>

//               <ErrorComponent error={error?.file} />


//               <div className='w-full mt-2'>
//                 <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Query</h6>
//                 <textarea name="query" value={data?.query} onChange={handleChange} type='text' className='w-full p-1 border focus:ring-0 focus:outline-none' />
//               </div>


//                   <button onClick={submitForm} className='text-[12px] 2xl:text-[15px] flex font_normal mt-2 items-end justify-end bg-black text-white p-2'>
//                     SUBMIT
//                   </button>

//               </div>

//               <div data-aos="fade-up" className='md:ml-[4%] md:w-[48%] mt-10'>
//                 <div className='w-[100%]'>
//                 <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.201402509898!2d77.5725512!3d12.9205498!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14293cbbedf9%3A0x4f12794ce5a209a4!2sFidelitus%20Corp!5e0!3m2!1sen!2sin!4v1691664501989!5m2!1sen!2sin" className='w-full' height="400"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
//                 </div>
//               </div>
//            </div>


          

//         </div>
        


       










      
//         </div>
//         </div>

      

//       <h1 data-aos="fade_up" className=' text-center font_thicker text-[17px] mt-10'>Be Part of Our   <span className='text-[#4190ac] font_medium'>Growing PAN India </span>  Presence</h1>


//       <div className='grid items-center justify-center grid-cols-3 px-10 mt-10 mb-20 place-self-center place-content-center md:flex'>
//         <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black border-l md:border-l-0'>BANGALORE</span>
//         <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>HYDERABAD</span>
//         <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>CHENNAI</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black border-l md:border-l-0'>MUMBAI</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>DELHI</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>AHMEDABAD</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black border-l md:border-l-0'>KOLKATA</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>PUNE</span>
//         <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black md:border-none'>KOCHI</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>SALEM</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>GURGAON</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black border-l md:border-l-0'>MANAGALORE</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>HASAN</span>
//         <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black md:border-none'>KALBURGI</span>
//        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>KERALA</span>
//         <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>HAMPI</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black border-l md:border-l-0'>HOSPET</span>
//         <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black'>TUMAKUR</span>
//         <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black md:border-none'>CHIKKAMAGALORE</span>
//         <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black font_normal cursor-pointer border-r border-black md:border-none'>SHIVAMOGGA</span>
        
//       </div>


//         {/* <div className='bg-[#f7f3ef] px-[10vw] py-20 md:flex justify-between'>
//             <h6 className='font_thicker font-[500] text-[30px] md:w-[70%]'>We provide all kinds of IT & Non IT Candidates that vow your organization <span className='text-[#4190ac]'>success</span></h6>


//             <button className='mt-10 md:mt-0'>
              
//               <Link href={`tel:${mobile}`} target='_blank'>
//               <div className='flex items-center bg-[#000] text-white rounded p-3 transition duration-300 ease-in hover:-translate-y-1 '>
//                 <BsChatLeftDots />
//                 <h6 className='ml-3'>Let&apos;s Talk</h6>
//               </div>
//               </Link>
//             </button>


//         </div> */}
//     </div>
//   )
// }

// export default Carrer